var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"4","height":"5","viewBox":"0 0 4 5","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('circle',{attrs:{"cx":"2","cy":"2.5","r":"2","fill":"#E0E0E0"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }